import React from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";

const useStyles = createUseStyles((theme) => ({
	message: {
		marginRight: "5px",
	},
}));

const Comments = (props) => {
	let { text } = props;
	const classes = useStyles();

	return (
		<>
			<span className={classes.message}>+</span>
			<span className={classNames(["icon24 icon-infinite", classes.message])} />
			<span>{text.message}</span>
		</>
	);
};

export default Comments;
